module.exports = __webpack_public_path__ + "static/media/mentor_mentoring_about3.361001cf.webp";